import * as React from "react";
const SvgFiRrAlarmPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-alarm-plus_svg__a)">
      <path
        fill="#062147"
        d="M17 13a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-2 0v-3H8a1 1 0 0 1 0-2h3V9a1 1 0 0 1 2 0v3h3a1 1 0 0 1 1 1m6 0a10.95 10.95 0 0 1-2.668 7.173C21.178 20.621 22 21.49 22 23a1 1 0 0 1-2 0c0-1-.858-1.194-1.122-1.229a1 1 0 0 1-.189-.045A10.95 10.95 0 0 1 12 24c-2.514 0-4.833-.848-6.687-2.272a1 1 0 0 1-.203.044c-.252.035-1.11.229-1.11 1.229a1 1 0 0 1-2 0c0-1.51.821-2.378 1.668-2.827A10.95 10.95 0 0 1 1 13.001C1 7.272 5.401 2.553 11 2.046V1a1 1 0 0 1 2 0v1.046C18.599 2.553 23 7.272 23 13m-11 9c4.962 0 9-4.038 9-9s-4.038-9-9-9-9 4.038-9 9 4.038 9 9 9m7.215-22a1 1 0 0 0 0 2C21.024 2 22 3.288 22 4.5a1 1 0 0 0 2 0C24 1.977 21.898 0 19.215 0M2 4.5C2 3.288 2.976 2 4.785 2a1 1 0 0 0 0-2C2.102 0 0 1.977 0 4.5a1 1 0 0 0 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-alarm-plus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAlarmPlus;
